<template>
  <div class="container wc-container" v-if="!isLoading">
  <h3 style="margin-bottom:30px;" >Dashboard</h3>
  <Row :gutter="16">
    <Col :xs="{span: 24, offset: 0}" :sm="{span: 12}" :md="{span: 8}">
      <ConViewers></ConViewers>
    </Col>
    <Col :xs="{span: 24, offset: 0}" :sm="{span: 12}" :md="{span: 8}">
      <TotalAttendees></TotalAttendees>
    </Col>
    <Col :xs="{span: 24, offset: 0}" :sm="{span: 12}" :md="{span: 8}">
      <RegVSAtt></RegVSAtt>
    </Col>
    <!--
    <Col :xs="{span: 24, offset: 0}" :sm="{span: 12}" :md="{span: 6}">
      <Card class="stats-card">
        <div class="stats-number">{{avgMinutes}}</div>
        <div class="stats-title">Avg. Duration</div>
      </Card>
    </Col>
    -->
  </Row>
  <Row :gutter="16">
    <ConViewersGraph :session-id="this.webcast.currentSessionId"></ConViewersGraph>
  </Row>
  </div>
</template>

<script>
import {
  mapState,
  mapGetters,
  mapActions
} from 'vuex'
import moment from 'moment'
import ConViewers from "./ConViewers"
import ConViewersGraph from "./ConViewersGraph"
import RegVSAtt from "./RegVSAtt"
import TotalAttendees from "./TotalAttendees"

export default {
  components: {
    RegVSAtt,
    ConViewers,
    ConViewersGraph,
    TotalAttendees
	},
  data() {
    return {
      isLoading: false
    }
  },
  computed: {
    ...mapGetters('webcast', {
      webcast: 'getCopy',
    }),
    ...mapGetters('page-settings', {
      pageSettings: 'getCopy',
    })
  },
  methods: {
    ...mapActions('registrations', {
      findRegistrationsAction: 'find'
    }),
    ...mapActions('realtime-stats', {
      findStatsAction: 'find'
    }),
  },
  created(){
    this.$store.commit('registrations/clearAll');
    this.$store.commit('session-connections/clearAll');
    this.$store.commit('realtime-stats/clearAll');

    this.$data.isLoading = true
    this.findRegistrationsAction({
      query:{
        webcastId: this.webcast._id
      }
    });
    this.findStatsAction({query:{
      webcastId: this.webcast._id,
      sessionId: this.webcast.currentSessionId
    }});

    this.$data.isLoading = false
  }
}
</script>

<style>

</style>
